var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",attrs:{"id":_vm.id}},[_c('div',{staticClass:"modal-content"},[_c('h4',[_vm._v(_vm._s(_vm.header))]),_vm._t("default")],2),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"modal-action modal-close waves-effect waves-green btn-flat",on:{"click":_vm.onAccept}},[_vm._v(" "+_vm._s(_vm.button)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }